import React from 'react';
import { motion } from 'framer-motion';  // Import motion from framer-motion
import rightIcon from "../assets/images/right-icon.png";
import leftIcon from "../assets/images/left-icon.png";
import BgImg from "../assets/images/assetsflex-bg.png";


// Assets Flexibility Section component
export const AssetsFlexibilitySection = () => {
  return (
    <motion.section
      className="relative bg-bottom bg-cover shadow-[0_-4px_10px_rgba(0,0,0,0.9)]"
      id="assets-flexibility-section"
      style={{ backgroundImage: `url(${BgImg})`, 
        height: '800px',
        width:"100%",
        padding:"30px",
      }}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.1 }} 
      transition={{ duration: 0.5 }}
    >
      {/* Overlay Layer */}
      <div className="absolute inset-0 bg-black opacity-50"></div>

      <div className="z-10 w-full max-w-[1180px] mx-auto grid lg:grid-cols-2 text-white pt-[156px]">
        
        {/* First Part - Left Section */}
        <motion.div
          className="flex flex-col justify-center items-start z-50 mx-[26px] md:mx-[12px] lg:ml-[100px]"
          initial={{ opacity: 0, x: -500 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ 
            duration: 2,
            type: "spring",
            stiffness: 50,
            damping: 15,
            delay: 0.3
          }}
        >
          <img src={leftIcon} alt="Icon" className="w-12 h-12 mb-8" />
          <h2 className="text-[48px] 1024:text-[64px] font-semibold w-[300px] font-sans text-white leading-[111.111%] tracking-[-0.72px] mb-8">Asset Ownership</h2>
          <p className="text-[24px] text-[#FFF] opacity-70 w-[350px] leading-[166.6%] font-dm-sans">Maintain self custody of deposited assets</p>
        </motion.div>

        {/* Third Part - Right Section */}
        <motion.div
          className="flex flex-col justify-center items-end z-20 mx-[26px] md:mx-[12px] lg:mr-[100px]"
          initial={{ opacity: 0, x: 500 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ 
            duration: 2,
            type: "spring",
            stiffness: 50,
            damping: 15,
            delay: 0.3
          }}
        >
          <img src={rightIcon} alt="Icon" className="w-12 h-12 mb-8" />
          <h2 className="text-end text-[48px] 1024:text-[64px] font-semibold w-[300px] font-sans text-white leading-[111.111%] tracking-[-0.72px] mb-8">Flexible borrowing</h2>
          <p className="text-[24px] opacity-70 text-[#FFF] text-end mt-2 w-[350px] leading-[166.6%] font-dm-sans">High LTV strategies and one click entry</p>
        </motion.div>
      </div>
    </motion.section>
  );
};
